import styled from 'styled-components';

export const CardMainSection = styled.div`
  margin: 10px 0 0;
  cursor: pointer;
  overflow: hidden;

  @media (max-width: 720px) {
    margin: 10px 0 10px;
    padding-right: 0;
    cursor: default;
  }
  transition:
    all 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
    box-shadow 0.3s ease 0s;

  &.lowOpacity {
    opacity: 0.4;
  }
  border-radius: 4px;

  .animated_card {
    position: relative;
    top: 54px;
    transition: all 0.25s ease-out;
    height: 100%;
    display: flex;
    flex-direction: column;

    @media (max-width: 720px) {
      top: 0;
    }
  }

  &.hoverable_section {
    &:hover {
      .add_btn_filled {
        opacity: 1;
      }
      .animated_card {
        top: 0;
      }
    }
  }
`;
export const TextSection = styled.div`
  padding: 0px 6px 10px;
  @media (max-width: 720px) {
    position: relative;
    border: solid 1px #dadada;
    border-top: none;
    min-height: ${(props) => (props.lightning ? '206px' : '188px')};
  }
  .textContainer {
    min-height: ${(props) => (props.lightning ? '174px' : '156px')};
  }
`;
export const AddButtonContainer = styled.div`
  margin: 0px 4px;
  @media (max-width: 720px) {
    position: absolute;
    bottom: 12px;
    width: 88%;
  }
`;
export const CardTitle = styled.h3`
  font-size: 14px;
  color: hsl(0deg 0% 0% / 87%);
  overflow: hidden;
  padding: 9px 0 0;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 0;
  font-weight: 500;
  height: 42.6px;
`;

export const CardPrice = styled.div`
  display: flex;
  align-items: baseline;
  padding: 10px 0 0;
  flex-direction: ${(props) => (props.perUnit ? 'column' : '')};
  .mainPriceContainer {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .pricePerCount {
    color: rgb(0 0 0 / 38%);
    font-size: clamp(9px, 2vw, 12px);
    @media (min-width: 768px) {
      margin-right: 15px;
    }
  }
  .mainPrice {
    font-weight: 600;
    padding-right: 5px;
    font-size: clamp(14px, 2vw, 18px);
    color: hsl(0deg, 0%, 0%, 87%);
    display: ${(props) => (props.perUnit ? 'flex' : '')};
  }
  .strikePrice {
    text-decoration: line-through;
    font-size: clamp(11px, 2vw, 14px);
    padding-right: 6px;
    font-weight: 500;
    color: #9d9d9d;
  }
  .discount {
    font-size: clamp(10px, 2vw, 14px);
    color: #63b0a8;
    font-weight: 600;
  }
  sup {
    font-size: 10px;
    padding-right: 1px;
  }
`;
